import router from '@/router'


// 未授权时可访问的白名单
const whiteList = ['/']

router.beforeEach(async (to, from, next) => {
  if (sessionStorage.getItem('token')) {
    next()
    // getUserInfo().then(user => {
    //   if(user.code==0){
    //
    //     next()
    //   }else{
    //     window.location.href='./404'
    //   }
    //
    // })
  } else if (whiteList.includes(to.path)) {
    next()
  } else {
    router.push('/')
    sessionStorage.clear()

  }


})





// WEBPACK FOOTER //
// ./src/router/permission.js